import * as Yup from 'yup';
import { getTrimmedValue, isValidPhoneNumber } from '../../../../../../../utils/utilities';
import {
  getEmailValidationSchema,
  getHrDesignationSchema,
  getNameValidationSchema
} from '../../../../../../../utils/ValidationSchema';

const phoneValidation = Yup.string()
  .transform((currentVal) => getTrimmedValue(currentVal, false))
  .test({
    name: 'phone',
    message: 'Please add a valid Phone number',
    test: function (value) {
      let intlPhoneNumber = `${this.parent.country_code + '' + value}`;
      if (value) {
        return isValidPhoneNumber(intlPhoneNumber);
      } else {
        return true;
      }
    }
  });

export default Yup.object().shape({
  hr_info: Yup.object().shape({
    full_name: getNameValidationSchema({ message: 'Full Name' }).required(
      'Please provide their Full Name'
    ),
    email: getEmailValidationSchema({ isNullable: true }),
    phone: phoneValidation
  }),
  manager_info: Yup.object().shape({
    full_name: getNameValidationSchema({ message: 'Full Name' }).when('refCount', {
      is: (refCount) => {
        return refCount === 0;
      },
      then: getNameValidationSchema({ message: 'Full Name' }).required(
        'Please provide their Full name'
      )
    }),
    email: getEmailValidationSchema({ isNullable: true }),
    phone: phoneValidation
  }),
  references_additional: Yup.array().of(
    Yup.object().shape({
      full_name: getNameValidationSchema({ message: 'Full Name', isRequired: true }),
      email: getEmailValidationSchema({ isRequired: true }),
      phone: phoneValidation.required('Please enter a valid phone number'),
      designation: getHrDesignationSchema({ message: 'Designation', isRequired: true }),
      linkedin_url: Yup.string()
        .transform((currentVal) => getTrimmedValue(currentVal, false))
        .matches(
          /^((https?):\/\/)?(www.)?[a-z0-9-]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#-]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
          'Please enter valid url'
        )
    })
  )
});
